import { Box } from '@mui/material';
import SupplierView from '../Supplier/SupplierView';
import { paintSaveAndNextButton } from '../../shared/UtilFunctions';

export default function AddSupplierStep(props) {
  const { commonProps, strategyProps, showSaveButton, strategyInformation } =
    props;
  const {
    setSuppliersDirty,
    setParentSupplierData,
    userInfoMap,
    setParentNonStrategicSupplierData,
    supplierScopeOverview
  } = strategyProps;

  const { incrementAPIInProgress, decrementAPIInProgress, isEdit } =
    commonProps;

  return (
    <Box>
      <SupplierView
        key={strategyInformation}
        strategyInformation={strategyInformation}
        commonProps={commonProps}
        incrementAPIInProgress={incrementAPIInProgress}
        decrementAPIInProgress={decrementAPIInProgress}
        showSensitiveInfo={true}
        isEdit={isEdit}
        isCreate={true}
        userInfoMap={userInfoMap}
        supplierScopeOverview={supplierScopeOverview}
        setSuppliersDirty={setSuppliersDirty}
        setSuppliersData={setParentSupplierData}
        setNonStrategicSuppliersList={setParentNonStrategicSupplierData}
        donotEnforceCommentsWhenSupplierTypeChanged={true}
      />

      {paintSaveAndNextButton(showSaveButton)}
    </Box>
  );
}
